'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Fares.FaresClassUsageGrid', dependencies).controller('FaresClassUsageGridController', require('./controllers/FaresClassUsageGridController')).directive('rmFaresClassUsageGridModal', require('./directives/FaresClassUsageGridModalDirective'));